module.exports = __webpack_public_path__ + "img/rks.84f05598.png";